<template>
	<div>
		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'penaltiesRewards/delete'"
			:parameters="{ id: myItem ? myItem.id : null }"
			@on-delete="$refs.table.resetShownRows(); filter()">
			{{ tab === 1 ? 
				$T('EmployeePenaltiesAndRewards.delete-message-penalty') :  
				$T('EmployeePenaltiesAndRewards.delete-message-bonus')
			}}

			{{ myItem ? myItem.punishmentRewardTypes ? myItem.punishmentRewardTypes.name : ' ' : null }}
			{{ $T('?') }}
		</v-delete-dialog>

		<!-- add or edit dialog -->
		<v-dialog v-model="dialog" max-width="550">
			<v-form ref="form" @submit.prevent="submit" :disabled="submitLoading">
				<v-card>
					<v-card-title>
						<span class="me-n6">
							{{
								(myItem  ? $T('edit') : $T('add')) +
								' ' +
								(+tab === penaltyRewardType.penalty ? $T('penalty') : $T('reward'))
							}}
						</span>
						<v-spacer />
						<v-btn icon @click="dialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense class="ma-0">
							<!-- employeeId -->
							<!-- <v-col sm="6" cols="12">
								<v-autocomplete
									v-model="dialogData.employeeId"
									:label="$T('inputs.employee-name')"
									:items="employees"
									:item-text="item => `(${item.code}) ${item.arabicFullName}`"
									item-value="employeeId"
									hide-details
									dense
									outlined
									ref="employeeInput"
									:rules="[rules.required]"
								></v-autocomplete>
							</v-col> -->
							
							<!-- suggested-by -->
							<v-col sm="12" cols="12">
								<v-autocomplete
									v-model="dialogData.suggestedByEmployeeId"
									:label="$T('inputs.suggested-by')"
									:items="employees.filter(c => c.employeeId !== dialogData.employeeId)"
									:item-text="item => `(${item.code}) ${item.arabicFullName}`"
									item-value="employeeId"
									hide-details
									dense
									outlined
									ref="employeeInput"
								></v-autocomplete>
							</v-col>

							<!-- type -->
							<v-col sm="4" cols="12">
								<v-autocomplete
									v-model="dialogData.typeId"
									:label="
										+tab === penaltyRewardType.penalty
											? $T('inputs.penalty-type')
											: $T('inputs.reward-type')
									"
									:items="+tab === penaltyRewardType.penalty ? penalties : rewards"
									item-text="name"
									item-value="id"
									hide-details
									dense
									outlined
									@change="e => {
										const item = getTypeDueCurrentTab(e);
										dialogData.effectType = item.valueType;
										dialogData.typeValue = item.value;
									}"
									:rules="[rules.required]"
								></v-autocomplete>
							</v-col>

							<!-- effect-type -->
							<v-col sm="4" cols="12">
								<v-autocomplete
									v-model="dialogData.effectType"
									:items="penaltyRewardValueTypes"
									item-value="id"
									item-text="name"
									:label="$T('inputs.effect-type')"
									hide-details
									dense
									outlined
									:rules="[rules.required]"
								></v-autocomplete>
							</v-col>

							<!-- value -->
							<v-col sm="4" cols="12">
								<v-text-field
									v-model.number="dialogData.typeValue"
									:label="typeValueLabel"
									hide-details
									:prefix="dialogData.effectType === penaltyRewardValueType.rate ? '%' : null"
									dense
									outlined
									:rules="[rules.isNumber]"
								></v-text-field>
							</v-col>
				
							<!-- date -->
							<v-col sm="6" cols="12">
								<bee-date-input
									v-model="dialogData.date"
									:label="$T('inputs.date')"
									hide-details
									dense
									prepend-icon="$calendar"
									user-menu-picker
									:rules="[rules.required]"
								></bee-date-input>
							</v-col>
				
							<!-- execution date -->
							<v-col sm="6" cols="12">
								<bee-date-input
									v-model="dialogData.executionDate"
									:label="$T('inputs.execution-date')"
									hide-details
									dense
									prepend-icon="$calendar"
									:menu-picker-months-over-max="3"
									user-menu-picker
									:rules="[rules.required]"
								></bee-date-input>
							</v-col>
							
							<!-- notes -->
							<v-col cols="12">
								<v-textarea
									v-model="dialogData.notes"
									:label="$T('inputs.notes')"
									rows="2"
									auto-grow
									hide-details
									outlined
									dense
								></v-textarea>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							type="submit"
							color="secondary"
							:loading="submitLoading"
						>
							{{ $T('save') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
		<!-- tabs -->
		<v-tabs 
			v-model="tab" 
			@change="$refs.table.resetShownRows(); $refs.form.resetValidation(); filter()"
		>
			<v-tab>
				<!-- <v-icon class="me-1"> mdi-gift-outline </v-icon> -->
				{{ $T('tabs.rewards') }}
			</v-tab>
			<v-tab
			>
				<!-- <v-icon class="me-1"> mdi-alert-octagon-outline </v-icon> -->
				{{ $T('tabs.penalties') }}
			</v-tab>
		
		</v-tabs>
		<v-divider></v-divider>

		<div class="pa-2">
			<v-form ref="form" @submit.prevent="$refs.table.resetShownRows(); filter()">
				<v-row
					dense
					class="align-center ma-0 mb-2">
					<!-- from-date -->
					<v-col
						lg="2"
						md="3"
						sm="4"
						cols="12">
						<bee-date-input
							v-model="filterData.fromDate"
							:label="$T('inputs.from')"
							dense
							hide-details
							changeable-with-arrows
							changeable-on-scroll
							prepend-icon="$calendar"
							user-menu-picker></bee-date-input>
					</v-col>
	
					<!-- to-date -->
					<v-col
						lg="2"
						md="3"
						sm="4"
						cols="12">
						<bee-date-input
							v-model="filterData.toDate"
							:label="$T('inputs.to')"
							dense
							hide-details
							changeable-with-arrows
							changeable-on-scroll
							prepend-icon="$calendar"
							user-menu-picker></bee-date-input>
					</v-col>
					<!-- filter -->
					<v-col cols="2">
						<v-autocomplete
							v-model="punishmentTypeId"
							:items="+tab === 1 ? penalties : rewards"
							item-text="name"
							item-value="id"
							:label="tab === 1 ? 'نوع العقوبة' : 'نوع المكافأة' "
							outlined
							dense
							hide-details
							:disabled="loading"
						/>
					</v-col>
					<v-col cols="auto">
						<v-btn
							type="submit"
							:disabled="Boolean(filterData.employee && filterData.sectionId && filterData.fromDate && filterData.toDate)"
							class="me-1"
							outlined
							small
							color="primary"	
						>
							<v-icon small left>mdi-magnify</v-icon>
							{{ $T('default-buttons.search') }}
						</v-btn>
						<v-btn
							v-if="filterData.employee || filterData.sectionId || filterData.fromDate || filterData.toDate"
							style="min-width: 30px"
							class="px-0"
							outlined
							small
							color="alert"
							@click="$refs.table.resetShownRows(); clearFilters(); filter()"
						>
							<v-icon small>$clear</v-icon>
						</v-btn>
					</v-col>
	
					<v-spacer />
	
					<!-- add button -->
					<v-col cols="auto">
						<v-btn
							small
							color="primary"
							@click="myItem = null; dialog = true">
							<v-icon
								size="20"
								left>
								$add
							</v-icon>
							{{ tab === 1 ? $T('add-penalty') : $T('add-reward') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-form>

			<!-- table -->
			<bee-handy-table
				ref="table"
				:headers="headers"
				:items="[]"
				:height="$vuetify.breakpoint.height - 200"
				:data-table-props="{ disableSort: true }"
				dense
				zebra
				fixed-header
				hide-default-footer
				pagination-on-scroll
				pagination-on-scroll-server-items
				:server-items-length="totalItems"
				:options-scroll.sync="scrollOptions"
				:shown-rows-text="$T('shown-rows-text')"
				@pagination-on-scroll:reach-last-row="filter"
				:loading="loading"
				>
				<!-- actions -->
				<template v-slot:item.actions="{ item }">
					<div class="d-flex">
						<v-btn
							@click="myItem = item; dialog = true"
							icon
							color="edit-color">
							<v-icon>$edit</v-icon>
						</v-btn>
						<v-btn
							@click="myItem = item; deleteDialog = true"
							icon
							color="alert">
							<v-icon>$delete</v-icon>
						</v-btn>
					</div>
				</template>
			</bee-handy-table>
		</div>
	</div>
</template>

<script>
import moment, { DATE_FORMAT } from '@/utils/moment';
import { mapState } from 'vuex';
import { penaltyRewardType, penaltyRewardValueType, penaltyRewardValueTypes } from '@/utils/enum'
import rules from '@/utils/validation rules';
export default {
	name: 'EmployeePenaltiesAndRewards',

	data() {
		return {
			penaltyRewardType,

			dialog: false,
			tab: 0,

			// filter
			filterData: {
				employeeName: null,
				sectionName: null,
				fromDate: moment().startOf('month').format(DATE_FORMAT),
				toDate: moment().endOf('month').format(DATE_FORMAT),
			},

			rewordsTypes: ['بطاقة شكر', 'مكافئة مادية'],

			// data
			dialogData: {
				type: null,
				date: null,
				executionDate: null,
				details: null,
				suggestedByEmployeeId: null,
				typeId: null,
				effectType: null,
				typeValue: null,
				notes: null
			},

			// ! to delete
			penaltyItems: [
				{
					penaltyType: 'خصم 3 ايام',
					sectionName: 'هندسة ميكانيك',
					date: new Date(),
					executionDate: new Date(),
					details: 'بسبب شجار',
				},
				{
					penaltyType: 'إنذار مسجل',
					sectionName: 'هندسة ميكانيك',
					date: new Date(),
					executionDate: new Date(),
					details: 'تأخير متكرر',
				},
			],

			rewardItems: [
				{
					rewardType: 'بطاقة شكر',
					sectionName: 'هندسة ميكانيك',
					date: new Date(),
					executionDate: new Date(),
					details: 'تشجيع الفريق',
				},
				{
					rewardType: 'بطاقة شكر',
					sectionName: 'هندسة ميكانيك',
					date: new Date(),
					executionDate: new Date(),
					details: '',
				},
				{
					rewardType: 'مكافئة مادية',
					sectionName: 'هندسة ميكانيك',
					date: new Date(),
					executionDate: new Date(),
					details: 'بقيمة 1000 ل.س',
				},
			],
			loading: false,
			totalItems: 0,
			scrollOptions: {},
			submitLoading: false,
			penaltyRewardValueType,
			penaltyRewardValueTypes,
			rules,
			myItem: null,
			deleteDialog: false,
			punishmentTypeId: null
		};
	},

	watch: {
		// dialog(newVal) {
		// 	if (!newVal) {
		// 		this.dialogData.type = null;
		// 		this.dialogData.date = null;
		// 		this.dialogData.executionDate = null;
		// 		this.dialogData.details = null
		// 		this.dialogData.suggestedByEmployeeId = null
		// 		this.dialogData.typeId = null
		// 		this.itemId = null
		// 	}
		// },

		dialog(val) {
			console.log(this.myItem)
			if (val) {
				if (this.myItem !== null) {
					this.dialogData.employeeId = this.myItem.employeeId;
					this.dialogData.suggestedByEmployeeId = this.myItem.suggestedByEmployeeId;
					this.dialogData.date = this.myItem.date;
					this.dialogData.executionDate = this.myItem.dateOfStarting;
					this.dialogData.typeId = this.myItem.typeId;
					this.dialogData.effectType = this.myItem.valueType;
					this.dialogData.typeValue = this.myItem.value;
					this.dialogData.notes = this.myItem.notes;
				}
				this.$nextTick(() => this.$refs.employeeInput.focus());
			} else {
				this.$refs.form.reset();
				this.myItem = {};
				this.itemId = null
			}
		},
	},

	computed: {
		...mapState({
			employees: state => state.employee.employees,
			penalties: state => state.penaltiesRewards.penalties,
			rewards: state => state.penaltiesRewards.rewards,
		}),

		headers() {
			const headers = [
				{},
				{
					text: this.$T('headers.section-name'),
					name: 'section',
					value: 'employee',
					setValueExpr: val => val.sectionName
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: DATE_FORMAT,
				},
				{
					text: this.$T('PenaltiesAndRewards.headers.executionDate'),
					name: 'dateOfStarting',
					value: 'dateOfStarting',
					type: 'date',
					dateFormat: DATE_FORMAT,
				},
				{
					text: this.$T('headers.details'),
					name: 'details',
					value: 'details',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 40,
				},
			];

			// for penalty tab
			if (this.tab === 1) {
				headers.splice(0, 1, {
					text: this.$T('PenaltiesAndRewards.headers.penaltyType'),
					name: 'punishmentRewardTypes',
					value: 'punishmentRewardTypes',
					setValueExpr: val => val.name
				});
			} else if (this.tab === 0) {
				// for reward tab
				headers.splice(0, 1, {
					text: this.$T('PenaltiesAndRewards.headers.rewardType'),
					name: 'rewardType',
					value: 'punishmentRewardTypes',
					setValueExpr: val => val.name
				});
			}

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2';
			}

			return headers;
		},

		typeValueLabel() {
			switch(this.dialogData.effectType){
			case penaltyRewardValueType.rate: return this.$T('inputs.percent');
			case penaltyRewardValueType.days: return this.$T('inputs.days-count');
			default: return this.$T('inputs.value');
			}
		}
	},

	methods: {
		filter(newScrollOptions, isFirst = false) {
			this.loading = true;
			let page = 1;
			// const { itemsPerPage } = this.scrollOptions;

			if (newScrollOptions) {
				page = newScrollOptions.page
			}
			if (this.needToResetTable) {
				this.$refs.table?.resetShownRows();
				this.needToResetTable = false;
			}

			this.$store.dispatch('penaltiesRewards/fetchAll', {
				type: this.tab,
				dateFrom: this.filterData.fromDate,
				dateTo: this.filterData.toDate,
				// sectionId: this.filterData.sectionId,
				employeeIds: this.$route.query.employeeId,
				page,
				perPage: 20,
				punishmentTypeId: this.punishmentTypeId
			}).then(({ data, total }) => {
				this.totalItems = total;
				this.$refs.table?.addScrollItems(data);
			}).finally(() => {
				this.loading = false;
				this.myItem = {}
			})
		},

		clearFilters() {
			this.filterData = {
				employee: null,
				sectionId: null,
				fromDate: null,
				toDate: null,
			};
			this.punishmentTypeId = null
		},

		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				const actionName = !this.myItem ? 'create' : 'update';
				this.$store.dispatch(`penaltiesRewards/${actionName}`, {
					id: this.myItem ? this.myItem.id : null,
					employeeId: this.$route.query.employeeId,
					suggestedByEmployeeId: this.dialogData.suggestedByEmployeeId,
					typeId: this.dialogData.typeId,
					date: this.dialogData.date,
					dateOfStarting: this.dialogData.executionDate,
					details: '-',
					notes: this.dialogData.notes,
					valueType: this.dialogData.effectType,
					value: this.dialogData.typeValue
				}).then(() => {
					this.needToResetTable = true;
					this.$refs.table.resetShownRows()
					this.filter();
					this.$eventBus.$emit(
						'show-snackbar',
						!this.myItem.id  ? this.$T('messages.add-done') : this.$T('messages.edit-done'),
						{ done: true }
					);
					this.dialog = false;
				}).catch((err) => {
					err.default && err.default(
						!this.myItem.id ? this.$T('messages.add-fail') : this.$T('messages.edit-fail'),
						false
					);
				}).finally(() => {
					this.submitLoading = false;
					this.dialog = false;
				})
			}
		},

		getTypeDueCurrentTab(id) {
			if(+this.tab === 1) {
				return this.getPenaltyById(id)
			} else {
				return this.getRewardById(id)
			}
		}
	},

	created () {
		this.loading = true
		// this.$store.dispatch('')
		if (this.penalties.length === 0 || this.rewards.length === 0) {
			this.$store.dispatch('penaltiesRewards/fetchAllTypes')
		}
		this.filter(null, true)
	}
};
</script>

<style></style>
